import { ensureArray } from 'utils/arrays';
import { ensureObject } from 'utils/objects';

const getCurrentFeature = ({ featureOnboarding, location }) =>
  ensureObject(
    ensureArray(featureOnboarding).find(o =>
      location?.pathname.includes(o?.feUrl),
    ),
  );

export default getCurrentFeature;
